import { Controller } from "@hotwired/stimulus"
import { toast } from "../lib/toast"

// Intercepts batch form submits and shows right-side toast on success/failure
export default class extends Controller {
  static values = {
    successMessage: { type: String, default: '処理を実行しました' },
    errorMessage: { type: String, default: 'エラーが発生しました' },
  }

  connect() {
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content
  }

  submit(event) {
    event.preventDefault()
    const form = event.target
    const submitBtn = form.querySelector('input[type="submit"], button[type="submit" ]')
    submitBtn && (submitBtn.disabled = true)

    fetch(form.action, {
      method: (form.method || 'post').toUpperCase(),
      headers: {
        'X-CSRF-Token': this.csrfToken,
        'Accept': 'text/html,application/json',
      },
    })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`)
        toast(this.successMessageValue, 'success')
      })
      .catch(() => {
        toast(this.errorMessageValue, 'error')
      })
      .finally(() => {
        submitBtn && (submitBtn.disabled = false)
      })
  }

  // toast is imported from shared lib
}
